import React from 'react'
import { Link } from 'react-router-dom'
import white from '../Img/Whiter.png'

function EventCreate() {
  return (
    <div>
        <div className='m-4 flex justify-center'>
        <h1 className='font-bold text-lg'>Add event Details</h1>
      </div>
      <div className='flex flex-col items-center space-y-2 mb-4'>
        <img src={white} alt="" />
        <h2 className='font-semibold absolute top-16 left-2 cursor-pointer p-2 bg-[#D3F36B] '>Add event photo</h2>
        <input type="file" className='ml-[90px]'/>
      </div>
      <div className='mx-3 space-y-2'>
        <h2 className='font-semibold'>Name</h2>
        <input className='px-3 w-[300px]  py-2 border border-black rounded-3xl' type="text" placeholder='Your Name' />
      </div>
      <div className='mx-3 space-y-2'>
        <h2 className='font-semibold'>Tag line for you</h2>
        <textarea name='message ' rows='4' className='px-3 w-[300px] border-black  py-2 border rounded-2xl' type="text" placeholder='Write about you' />
      </div>
      <div className='mx-3 space-y-2'>
        <h2 className='font-semibold'>Twitter</h2>
        <input className='px-3 w-[300px]  py-2 border border-black rounded-3xl' type="text" placeholder='Twitter link' />
      </div>
      <div className='mx-3 space-y-2 mb-24'>
        <h2 className='font-semibold'>LinkedIn</h2>
        <input className='px-3 w-[300px]  py-2 border border-black rounded-3xl' type="text" placeholder='LinkedIn link' />
      </div>
      <div className='drop-shadow-lg h-[60px] pb-3 flex justify-center items-center fixed bottom-0 bg-white shadow-lg shadow-black w-[350px]'>
        <Link to='/initiate' className='px-[70px] mb-4 mx-10  py-3 mt-8 bg-black font-semibold text-white rounded-3xl'>Create event</Link>
      </div>
      
    </div>
  )
}

export default EventCreate